/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'copy': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M6 1a1 1 0 011-1h12a1 1 0 011 1v12a1.001 1.001 0 01-1 1h-3V5a1 1 0 00-1-1H6V1z" _fill="#000"/><path pid="1" d="M1 6a1 1 0 00-1 1v12a.996.996 0 001 1h12a1 1 0 001-1V7a1 1 0 00-1-1H1z" _fill="#000"/>'
  }
})
